module.exports = __webpack_public_path__ + "img/Schalk.2105196e.jpg";